var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartIcon = function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.746 16.521a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM1.708 2.444a.962.962 0 0 1 0-1.923H2.86c.902 0 1.682.626 1.878 1.506L5.99 7.67c.196.88.976 1.506 1.878 1.506h7.512l1.442-5.77H7.477a.962.962 0 0 1 0-1.922h9.345a1.923 1.923 0 0 1 1.866 2.39l-1.442 5.768a1.923 1.923 0 0 1-1.866 1.457H7.868a3.846 3.846 0 0 1-3.755-3.012L2.86 2.444H1.71Z",
    fill: "#000"
  })));
};
export default SvgCartIcon;